import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "./customer-service";

export const HandleVersa = (value, set) => {
    set(!value)
}

export const ValidateEmail = (email) => {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!regex.test(email)) {
        return false;
    }
    return true
};

export const getSizeWindows = () => {
    const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [window]);
    return windowSize;
}

export function toNonAccentVietnamese(str) {
    str = str.replace(/A|Á|À|Ã|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/đ/g, "d");
    str = str.replace(/`|~/g, "");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    return Date.now().toString() + "_" + stringToSlug(str);;
}

export const numberOnly = (value) => {
    if (!isNaN(value)) return value;
    return ''
}

//check value exist
export const validateValue = (value) => {
    if (value === undefined || value === "" || value === null) {
        return false;
    }
    return true;
}

export const ConvertDateJS = (convertDate) => { // new Date() (in Reactjs)
    var date = new Date(convertDate.$d);
    const result = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    return result;
}

export function ConvertDate(str) { //date() (in html && spring)
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
}

export const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
};

export const moneyFormat = (money) => {
    const formattedNumber = money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return formattedNumber
}

export const countTimeExpired = (objectDto, setObjectDto) => {
    const navigation = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token || !objectDto) {
            LogOut(setObjectDto);
            navigation("/");
            return;
        }
        const tokenExp = JSON.parse(token);
        const checkTokenExpiration = () => {
            const currentDateTime = new Date();
            const year = currentDateTime.getFullYear();
            const month = ('0' + (currentDateTime.getMonth() + 1)).slice(-2);
            const day = ('0' + currentDateTime.getDate()).slice(-2);
            const hours = ('0' + currentDateTime.getHours()).slice(-2);
            const minutes = ('0' + currentDateTime.getMinutes()).slice(-2);
            const seconds = ('0' + currentDateTime.getSeconds()).slice(-2);
            const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
            if (timestamp > tokenExp.exprDate) {
                LogOut(setObjectDto);
                alert("Hết hạn kết nối đến server, vui lòng đăng nhập lại để tiếp tục");
                navigation("/");
                window.location.reload();
            }
        };
        const interval = setInterval(() => {
            checkTokenExpiration();
        }, 1000);
        return () => clearInterval(interval);
    }, []);
}

export const handleOpenPDF = (base64String) => {
    const base64 = base64String.replace(/^data:application\/pdf;base64,/, '');
    const byteCharacters = atob(base64);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    openInNewTab(blobUrl);
};

export function stringToSlug(str) {
    return str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
}

export const ValidatePhone = (phone, id) => {
    const regex = /^(0[3-9]{1}[0-9]{8})$/;
    if (!regex.test(phone)) {
        alert("Số điện thoại không đúng định dạng, vui lòng kiểm tra lại.");
        document.getElementById(id).focus();
        return false;
    }
    return true;
};
